import React from "react";
import { wrestlerAvatar, promotionAvatar } from "../lib/api";
import { ChampionCrown, useChampionId } from "./ChampionCrown";

/**
 * WrestlerPortrait — renders the wrestler's portrait with an optional
 * bottom visual layer showing the owner's Promotion logo.
 *
 * Layer order (bottom → top):
 *   1. Promotion backdrop (if the owner is in a promotion)
 *   2. Wrestler avatar (uploaded or default silhouette on transparent bg)
 *
 * Usage: place inside a wrapper with fixed dimensions / rounded corners /
 * overflow-hidden. This component fills the wrapper.
 *
 *   <div className="aspect-square rounded-lg overflow-hidden relative bg-[#0A051A]">
 *     <WrestlerPortrait w={w} />
 *   </div>
 */
export default function WrestlerPortrait({ w, className = "", showCrown = false }) {
  const champId = useChampionId();
  const promo = w?.owner_promotion;
  const bg = promo ? promotionAvatar(promo.id, promo.avatar_updated_at) : null;
  return (
    <>
      {bg && (
        <img
          data-testid={`portrait-bg-${w?.wrestler_id || "n"}`}
          src={bg}
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-95"
          draggable={false}
        />
      )}
      <img
        data-testid={`portrait-fg-${w?.wrestler_id || "n"}`}
        src={wrestlerAvatar(w)}
        alt={w?.name || ""}
        className={`relative w-full h-full object-cover ${className}`}
        draggable={false}
      />
      {showCrown && champId && promo?.id === champId && <ChampionCrown />}
    </>
  );
}
